module.exports = __webpack_public_path__ + "img/allottee4_7-8-2021.15113360.jpg";